import { render } from "./IconUTurnLeft.vue?vue&type=template&id=1a5fcc08"
import script from "./IconUTurnLeft.vue?vue&type=script&lang=js"
export * from "./IconUTurnLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__